import { Component, OnInit, EventEmitter, Output, Input, ViewChild, TemplateRef } from '@angular/core';

import { GestockService } from '../services/gestock.service';
import { ReponseWebService } from '../datastruct/Meloyi.module';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';


interface Customer {
  number: string;
  fullName: string;
  phone: string;
  address: string;
  companyName?: string;
  pricingType: 'Detaillant' | 'Demi-Gros' | 'Gros';
}

@Component({
  selector: 'app-customer-info',
  templateUrl: './customer-info.component.html',
  styleUrls: ['./customer-info.component.css']
})
export class CustomerInfoComponent {

  @Output() customerInfoEvent= new EventEmitter<any>();
  @Input() selectedCustomer : any;

  customerNumber  : any;
  //selectedCustomer: any | null = null;
  isNewCustomer = false;

  pricingType: 'Detaillant' | 'Demi-Gros' | 'Gros' = 'Detaillant';

  customers: any[] = [];

  @ViewChild('spinnerDialog', { static: false }) spinnerDialog: TemplateRef<any>;
  spinnerDialogRef : any ;

  @ViewChild('listClientsDialog', { static: false }) listClientsDialog: TemplateRef<any>;
  listClientsDialogRef : any ;


  displayedColumns: string[] = ['fullName', 'phone'];

  dataSource = [] ;  /*[
    { nom: 'Aliou Sow', telephone: '77 123 45 67' },
    { nom: 'Fatou Diop', telephone: '76 987 65 43' },
    { nom: 'Mamadou Fall', telephone: '70 456 78 90' }
  ];*/

  selectedRowIndex: number | null = null;


  samacaabiyoonwii = "" ;
  retourClientWS : any ;

  constructor(private dialog: MatDialog,
        private configServer: GestockService){

    if(this.selectedCustomer!=undefined)
      this.pricingType = this.selectedCustomer.pricingType;
  }


  ngOnInit(){
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii") ;
  }

  selectRow(row: any, index: number) {
    this.selectedRowIndex = index;
    console.log(this.dataSource[this.selectedRowIndex]) ;
  }

  getInfoClientBi(){
    this.openSpinnerDialog() ;
    this.configServer.getInfoClientBiPlus(this.samacaabiyoonwii, this.customerNumber.toString()).then( (retourbi) => {
      this.closeSpinnerDialog();
      this.retourClientWS = retourbi ;
      console.log("Clients :: ", this.retourClientWS) ;

      var statutreq = this.retourClientWS.statutreq;
      if(statutreq==1){
        if(this.retourClientWS.data.length < 2)
          this.selectedCustomer = this.retourClientWS.data[0] ;
        else{
          this.dataSource = this.retourClientWS.data ;
          this.openlistClientsDialog() ;
          //this.selectedCustomer = this.retourClientWS.data[0] ;
        }


        this.isNewCustomer = !this.selectedCustomer;
        if (this.selectedCustomer) {
          this.pricingType = this.selectedCustomer.pricingType;
          this.khamalMagMiLifiBees(this.selectedCustomer);
        } 
      }
      else{
         this.isNewCustomer = true ;
        this.pricingType = 'Detaillant';
      }
    }) ;        
  }


  khamalMagMiLifiBees(customer: any) {
    this.customerInfoEvent.emit(customer);
  }

  searchCustomer() {
    this.isNewCustomer = undefined;

    if(this.customerNumber==undefined)
      return ;
    this.getInfoClientBi(); 
  }

  registerCustomer(formValues: any) {
    const newCustomer: Customer = {
      ...formValues,
      phone: this.customerNumber,
      pricingType: this.pricingType
    };
    this.customers.push(newCustomer);
    this.selectedCustomer = newCustomer;
    this.isNewCustomer = false;
    this.khamalMagMiLifiBees(newCustomer);
  }

 //getInfoClientBi(samacaabiyoonwii: string, telephoneclient : string )

  reediter(){
    this.isNewCustomer = false ;
    this.selectedCustomer = undefined ;
  }

  goBack(){
    this.khamalMagMiLifiBees(this.selectedCustomer);    
  }


  choisirCeCLient(){
     if(this.selectedRowIndex!=undefined)
        this.selectedCustomer = this.dataSource[this.selectedRowIndex] ;
     this.closelistClientsDialog() ; 

    this.isNewCustomer = !this.selectedCustomer;
    if (this.selectedCustomer) {
      this.pricingType = this.selectedCustomer.pricingType;
      this.khamalMagMiLifiBees(this.selectedCustomer);
    } 
  }

  openlistClientsDialog() {
    this.listClientsDialogRef = this.dialog.open(this.listClientsDialog) ; 
  }

  closelistClientsDialog() {
    this.listClientsDialogRef.close();
  }

  openSpinnerDialog() {
    this.spinnerDialogRef = this.dialog.open(this.spinnerDialog) ; 
  }

  closeSpinnerDialog() {
    this.spinnerDialogRef.close();
  }



}
